<div class="bg-white py-sm-2 py-xxl-3" style="min-width: 310px">
  <app-banners />
</div>

<app-section-wrapper
  [title]="cmsFacade.featuredLinksTitle()"
  [description]="cmsFacade.featuredLinksSubtitle()"
  customClass="py-3 py-lg-4"
>
  <app-featured-links></app-featured-links>
</app-section-wrapper>

<app-section-wrapper
  titleClass="mb-3 mb-xxl-4"
  title="Ahorra más comprando Paquetes"
  titleId="packages-title"
  customClass="bg-white pt-4"
>
  <app-package-section
    [cardVersion]="1"
    [desktopItems]="6"
    [mobileItems]="3"
    scrollTargetId="packages-title"
  ></app-package-section>
</app-section-wrapper>

<app-section-wrapper
  titleClass="mb-3 mb-xxl-4"
  title="Súper ofertas de vuelos"
  titleId="flight-offers-title"
  customClass="bg-white py-4"
>
  <app-flight-offers></app-flight-offers>
</app-section-wrapper>

<app-section-wrapper
  titleClass="text-center mb-md-4"
  title="Por qué elegirnos"
  titleId="choose-us-title"
  customClass="py-4 py-lg-5"
>
  <app-section-why-choose-us></app-section-why-choose-us>
</app-section-wrapper>

<app-section-wrapper title="" customClass="py-3 py-lg-4">
  <app-section-boletin></app-section-boletin>
</app-section-wrapper>
